import React, { useState, useEffect} from 'react'
import { botUserName } from '../../configs/constant'
import { getSwapTotalData, getSwapHistoryData } from '../../util/bot-api'
import { formatAddress } from '../../util/format-data'
import toast, { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next'
import { v4 as uuidv4 } from 'uuid';

export default function Dashboard() {
  const [totalData, setTotalData] = useState({});
  const [tradeData, setTradeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const data = await getSwapTotalData();
      setTotalData(data.data);
      const tempData = await getSwapHistoryData('', 0, -100, 0, 'profit', 'desc', 10, 0);
      setTradeData(tempData.data);
      setLoading(false);
    };
    fetchData();
  }, []);

  const handleConnectTelegram = () => {
    window.open(`https://telegram.me/${botUserName}?start=connect`, "_blank");
  };

  const handleCopyTradeAddress = (address) => {
    window.open(`https://telegram.me/${botUserName}?start=__${address}`, "_blank");
  }

  const copyAddress = (value) => {
    navigator.clipboard.writeText(value).then(
      () => {
        // Successfully copied to clipboard
        toast.success(t('Address Copied To Clipboard Success Message'))
      },
      (err) => {
        // Failed to copy to clipboard
        console.error('Could not copy address: ', err);
      }
    );
  }

  return (
    <div className="flex flex-col gap-3 bg-customGray rounded-lg sm:p-5 p-2 w-full sm:min-w-[800px]">
      <div className="flex sm:flex-row flex-col justify-between items-center w-full">
        <div className="text-base sm:text-lg font-semibold text-center mb-2 sm:mb-0 sm:mt-0 mt-2">
          {t('Leaderboard of Elite Traders')}
        </div>
        <div className="sm:flex hidden items-center space-x-2 w-full sm:max-w-[200px] max-w-[400px]">
          <button
            onClick={handleConnectTelegram}
            className="bg-primary hover:bg-primary-hover text-white px-3 py-2 rounded-lg items-center text-sm w-full"
          >
            <i className="fab fa-telegram-plane mr-1"></i> Connect Telegram
          </button>
        </div>
      </div>
      {loading ? (
        <div className="sm:grid hidden grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 sm:gap-4">
          <div className="bg-background1 p-2 sm:p-4 rounded-lg shadow text-center animate-pulse">
          <i className="fas fa-users text-primary text-lg sm:text-2xl mb-1 sm:mb-2"></i>
            <div className="h-5 bg-gray-800 rounded w-3/4 mx-auto"></div>
          </div>
          <div className="bg-background1 p-2 sm:p-4 rounded-lg shadow text-center animate-pulse">
            <i className="fas fa-chart-bar text-primary text-lg sm:text-2xl mb-1 sm:mb-2"></i>
            <div className="h-5 bg-gray-800 rounded w-3/4 mx-auto"></div>
          </div>
          <div className="bg-background1 p-2 sm:p-4 rounded-lg shadow text-center animate-pulse">
            <i className="fas fa-chart-line text-primary text-lg sm:text-2xl mb-1 sm:mb-2"></i>
            <div className="h-5 bg-gray-800 rounded w-3/4 mx-auto"></div>
          </div>
        </div>
      ) : (
        <div className="sm:grid hidden grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 sm:gap-4">
          <div className="bg-background1 p-2 sm:p-4 rounded-lg shadow text-center">
            <i className="fas fa-users text-primary text-lg sm:text-2xl mb-1 sm:mb-2"></i>
            <p className="text-sm sm:text-lg">Total Traders: {totalData.traders}</p>
          </div>
          <div className="bg-background1 p-2 sm:p-4 rounded-lg shadow text-center">
            <i className="fas fa-chart-bar text-primary text-lg sm:text-2xl mb-1 sm:mb-2"></i>
            <p className="text-sm sm:text-lg">
              Total Volume: {(Number(totalData.totalSats) / Math.pow(10, 8)).toFixed(3)} BTC
            </p>
          </div>
          <div className="bg-background1 p-2 sm:p-4 rounded-lg shadow text-center">
            <i className="fas fa-chart-line text-primary text-lg sm:text-2xl mb-1 sm:mb-2"></i>
            <p className="text-sm sm:text-lg">
              Avg Profit: {totalData.profit}%
            </p>
          </div>
        </div>
      )}

      <div className="flex flex-col gap-2">
        <div className="flex flex-row gap-3 items-center">
          <div className="text-primary text-lg font-semibold">Top Traders</div>
          <div className="bg-primary hover:bg-priamry-hover text-white px-3 py-1 rounded-md cursor-pointer text-center" onClick={() => {window.open('https://dashboard.bitcoinuniverse.io', '_blank')}}>
            <a href="https://dashboard.bitcoinuniverse.io" target="_blank" rel="noopener noreferrer">
              {t('See Full Leaderboard')}
            </a>
          </div>
        </div>
        <div className="flex flex-row gap-2 bg-background2 rounded-lg py-2 px-3 w-full">
          <div className="sm:w-[20%] w-[40%]">Address</div>
          <div className="sm:w-[11%] w-[30%]">Profit %</div>
          <div className="sm:w-[13%] sm:flex hidden">APR %</div>
          <div className="sm:w-[11%] sm:flex hidden">30d %</div>
          <div className="sm:w-[10%] sm:flex hidden">Trades</div>
          <div className="sm:w-[20%] sm:flex hidden">Volume (BTC)</div>
          <div className="sm:w-[15%] w-[30%]">Actions</div>
        </div>

        {
          loading ? 
          <div className="animate-pulse flex flex-col gap-2">
            <div className="flex flex-row gap-2 bg-background1 rounded-lg py-5 px-3 items-center w-full">
            </div>
            <div className="flex flex-row gap-2 bg-background1 rounded-lg py-5 px-3 items-center w-full">
            </div>
            <div className="flex flex-row gap-2 bg-background1 rounded-lg py-5 px-3 items-center w-full">
            </div>
            <div className="flex flex-row gap-2 bg-background1 rounded-lg py-5 px-3 items-center w-full">
            </div>
            <div className="flex flex-row gap-2 bg-background1 rounded-lg py-5 px-3 items-center w-full">
            </div>
            <div className="flex flex-row gap-2 bg-background1 rounded-lg py-5 px-3 items-center w-full">
            </div>
            <div className="flex flex-row gap-2 bg-background1 rounded-lg py-5 px-3 items-center w-full">
            </div>
            <div className="flex flex-row gap-2 bg-background1 rounded-lg py-5 px-3 items-center w-full">
            </div>
            <div className="flex flex-row gap-2 bg-background1 rounded-lg py-5 px-3 items-center w-full">
            </div>
            <div className="flex flex-row gap-2 bg-background1 rounded-lg py-5 px-3 items-center w-full">
            </div>
          </div>
          :
          tradeData.map((item, index) => (
            <div key={uuidv4()} className="flex flex-row gap-2 bg-background1 rounded-lg py-2 px-3 items-center w-full">
              <div className="text-primary sm:w-[20%] w-[40%] cursor-pointer" onClick={() => copyAddress(item.address)}>{formatAddress(item.address)}</div>
              <div className={`${item.profit > 0 ? 'text-green-500' : 'text-red-500'} sm:w-[11%] w-[30%]`}>{item.profit}%</div>
              <div className={`${item.apr > 0 ? 'text-green-500' : 'text-red-500'} sm:w-[13%] sm:flex hidden`}>{item.apr}%</div>
              <div className={`${item['30dProfit'] > 0 ? 'text-green-500' : 'text-red-500'} sm:w-[11%] sm:flex hidden`}>{item['30dProfit']}%</div>
              <div className="sm:w-[10%] sm:flex hidden">{item.trades}</div>
              <div className="sm:w-[20%] sm:flex hidden">{(Number(item.totalBtcAmount) / Math.pow(10, 8)).toFixed(4)} BTC</div>
              <div className="sm:w-[15%] w-[30%]">
                <div className="bg-primary text-white px-3 py-1 rounded-md cursor-pointer text-center" onClick={() => handleCopyTradeAddress(item.address)}>COPY</div>
              </div>
            </div>
          ))
        }        
      </div>
    </div>
  )
}
